import { observer } from 'mobx-react-lite';
import { Card, CardContent, CardHeader, Typography } from '@mui/material';
import { useInjection } from 'inversify-react';
import LoadingScreen from '@shared/components/LoadingScreen';
import {
  IOsiServiceSaldoWidgetViewModel,
  IOsiServiceSaldoWidgetVmToken
} from '@shared/types/mobx/widgets/OsiServiceSaldo';
import { ServiceSaldoTable } from '@entities/osi/serviceSaldo';
import { useTranslation } from '@shared/utils/i18n';
import { AttachSaldoButton } from './AttachSaldoButton';

export const OsiServiceSaldoWidget: React.FC = observer(() => {
  const vm = useInjection<IOsiServiceSaldoWidgetViewModel>(IOsiServiceSaldoWidgetVmToken);
  const { fieldWithPrefix: fwp } = useTranslation();

  if (vm.isLoading) return <LoadingScreen />;

  return (
    <>
      {vm.saldoByGroup.map((item, index) => (
        <Card key={index} sx={{ mb: 2, maxWidth: 1000, minWidth: 500 }}>
          <CardHeader
            // minWidth:0 у content — чтобы длинное название группы переносилось (wordBreak),
            // а не растягивало карточку и не наезжало на кнопку в action.
            sx={{ '& .MuiCardHeader-content': { minWidth: 0 } }}
            subheader={
              <Typography variant="h5" color="textPrimary" sx={{ wordBreak: 'break-word' }}>
                {fwp(item, 'groupName')}
              </Typography>
            }
            // Правая часть заголовка группы: кнопка загрузки Excel начального сальдо.
            // Ссылка «Скачать шаблон» временно скрыта.
            action={<AttachSaldoButton groupId={item.groupId ?? 0} vm={vm} />}
          />
          <CardContent>
            <ServiceSaldoTable rows={item.items} />
          </CardContent>
        </Card>
      ))}
    </>
  );
});
